'use client';

/**
 * useReducedMotion Hook
 *
 * Detects user's preference for reduced motion for accessibility.
 */

import { useSyncExternalStore } from 'react';

/**
 * Subscribe to media query changes
 */
function subscribe(callback: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  mediaQuery.addEventListener('change', callback);
  return () => mediaQuery.removeEventListener('change', callback);
}

/**
 * Get current snapshot of reduced motion preference
 */
function getSnapshot(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Get server snapshot (always false for SSR)
 */
function getServerSnapshot(): boolean {
  return false;
}

/**
 * Returns true if the user prefers reduced motion
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export default useReducedMotion;
